import styled from "styled-components";
const StyledRetailGuidelines = styled.article`
& .navbar ~ welcome{

}
`;
export default StyledRetailGuidelines;
